'use client';

import clsx from 'clsx';

export default function HubSpotFormSkeleton({ className }: { className?: string }) {
  return (
    <div className={clsx('space-y-4', className)}>
      <div className='h-4 w-1/2 animate-pulse rounded bg-gray-200' />
      <div className='space-y-2'>
        <div className='h-4 w-1/4 animate-pulse rounded bg-gray-200' />
        <div className='h-10 animate-pulse rounded bg-gray-200' />
      </div>
      <div className='space-y-2'>
        <div className='h-4 w-1/4 animate-pulse rounded bg-gray-200' />
        <div className='h-10 animate-pulse rounded bg-gray-200' />
      </div>
      <div className='space-y-2'>
        <div className='h-4 w-1/4 animate-pulse rounded bg-gray-200' />
        <div className='h-20 animate-pulse rounded bg-gray-200' />
      </div>
      <div className='h-10 w-1/4 animate-pulse rounded bg-gray-200' />
    </div>
  );
}
